module.exports = __webpack_public_path__ + "img/3w.18868e25.svg";